import { useEffect, useMemo, useState } from 'react'

import { isMediaTrackInPlaylist, subscribeToMediaDock } from 'state/mediaPlaybackCoordinator'

// A media dropdown's playlist row says what a press will do: add the track,
// or take it out when it is already in the viewer's playlist.
export function playlistMenuLabel(inPlaylist) {
    return inPlaylist ? 'Remove from playlist' : 'Add to playlist'
}

const membershipSignature = mediaKeys =>
    mediaKeys.map(mediaKey => (isMediaTrackInPlaylist(mediaKey) ? '1' : '0')).join('')

// Which of these tracks are in the dock playlist, kept current as it changes
// here, in the dock, or from another device. For a surface that builds a menu
// per item in a loop, where a hook per item is not possible.
export function useMediaKeysInPlaylist(mediaKeys) {
    const keys = (mediaKeys || []).filter(Boolean).map(String)
    const keysSignature = keys.join('\u0000')
    const [signature, setSignature] = useState(() => membershipSignature(keys))

    useEffect(() => {
        const currentKeys = keysSignature ? keysSignature.split('\u0000') : []
        const sync = () => setSignature(membershipSignature(currentKeys))
        sync()
        if (!currentKeys.length) return undefined
        return subscribeToMediaDock(sync)
    }, [keysSignature])

    return useMemo(() => {
        const currentKeys = keysSignature ? keysSignature.split('\u0000') : []
        return new Set(currentKeys.filter((_, index) => signature[index] === '1'))
    }, [keysSignature, signature])
}

export function useMediaKeyInPlaylist(mediaKey) {
    return useMediaKeysInPlaylist(mediaKey ? [mediaKey] : []).has(String(mediaKey || ''))
}
